import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filters: {},
};

const persistedFiltersSlice = createSlice({
  name: "persistedFilters",
  initialState,
  reducers: {
    setModuleFilters: (state, action) => {
      const { moduleKey, filters } = action.payload || {};
      if (!moduleKey) return;
      state.filters[moduleKey] = {
        ...(state.filters[moduleKey] || {}),
        ...(filters || {}),
      };
    },
    clearModuleFilters: (state, action) => {
      const { moduleKey } = action.payload || {};
      if (!moduleKey) return;
      delete state.filters[moduleKey];
    },
    clearAllPersistedFilters: state => {
      state.filters = {};
    },
  },
});

export const { setModuleFilters, clearModuleFilters, clearAllPersistedFilters } =
  persistedFiltersSlice.actions;

export default persistedFiltersSlice.reducer;
